<template>
  <Box variant="default" size="tight" class="participant shadow box--rounded">
    <Media size="tight">
      <MediaLeft
        v-if="statusObj"
        class="pdg- participant__status"
        :title="statusObj.title"
      >
        <Icon :id="statusObj.icon" :scale="0.6" :class="statusObj.class" />
      </MediaLeft>

      <MediaBody class="pdg-">
        <UserEntity :user="participant.user" />
      </MediaBody>

      <CenterMapOnUserBtn
        v-if="['bus', 'inspector'].includes(participant.user.type)"
        :username="participant.user.username"
      />
    </Media>
  </Box>
</template>

<script>
import UserEntity from '@/components/users/UserEntity';
import CenterMapOnUserBtn from '@/components/map/google/CenterMapOnUserBtn';

export default {
  components: {
    UserEntity,
    CenterMapOnUserBtn,
  },

  props: {
    participant: {
      type: Object,
      default: null,
    },
  },

  computed: {
    statusObj() {
      if (!this.participant || !this.participant.state) return null;

      switch (this.participant.state.state) {
        case 'created':
        case 'ready':
        case 'dialed-voip':
        case 'dialed-pstn':
          return {
            icon: 'hourglass',
            class: 'text-muted',
            title: this.$t('voip.call.status.connecting'),
          };
        case 'joined':
          return {
            icon: 'phone-up-alt',
            class: 'text-success',
            title: this.$t('voip.call.status.connected'),
          };
        case 'completed':
        case 'not-answered-voip':
        case 'not-answered-pstn':
        case 'failed':
        case 'busy':
        case 'canceled':
        case 'reserved':
        default:
          return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.participant {
  overflow: hidden;
}

.participant__status {
  border-right: 1px solid $alt-100;
}
</style>
